export interface ColumnModel {
  columns?: string[];
}
